import * as React from "react";
import {authorize} from "@athena-portal/components";

interface ICancelPolicyOrAutomaticRenewalChoiceWidgetProps {
    questionTitle: string;
    handleChoiceFunc: (choice: string) => any;
}

interface ICancelPolicyOrAutomaticRenewalChoiceWidgetState {
    cancelPolicyChosen: boolean;
    cancellationChoice: string;
}

@authorize
export class CancelPolicyOrAutomaticRenewalChoiceWidget
    extends React.Component<ICancelPolicyOrAutomaticRenewalChoiceWidgetProps, ICancelPolicyOrAutomaticRenewalChoiceWidgetState> {

    public static readonly CANCEL_OPT_EXISTING_POLICY: string = "cancelExistingPolicy";
    public static readonly CANCEL_RENEWAL: string = "cancelAutomaticRenewal";

    constructor(props: ICancelPolicyOrAutomaticRenewalChoiceWidgetProps) {
        super(props);

        this.state = {
            cancellationChoice: "",
            cancelPolicyChosen: false
        };
    }

    public render(): React.ReactNode {
        const cancellationReasonsKeys: any[] = [
            CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_RENEWAL,
            CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_OPT_EXISTING_POLICY
        ];

        return (
            <div className="panel cancellation-reason-widget">
                <div className="pt-3 pb-2 font-weight-700 cancellation-reason-question padding-top-32">
                    {this.props.questionTitle}
                </div>
                <div className="d-block input-group margin-top-14 w-100">
                    {cancellationReasonsKeys.map(
                        (key: any) =>
                            <div key={key}
                                 className="custom-control margin-bottom-20-padding-left-0">
                                <input className="custom-radiobutton cursor-pointer"
                                       type="radio"
                                       name={`${key}`}
                                       id={`option-${key}`}
                                       value={key}
                                       onChange={(e: any) => this.handleCancellationChoice(e)}
                                       checked={key === this.state.cancellationChoice}
                                />
                                <label id={`option-${key}-label`} className="checkbox-label driver-label"
                                       htmlFor={`option-${key}`}>
                                    { this.renderChoices(key)}
                                </label>
                            </div>
                    )}
                </div>
            </div>
        );
    }

    private renderChoices(key: string): any {
        if (key === CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_RENEWAL) {
            return (
                <>
                    Cancel on my renewal date (I don't want to renew)
                    <p className="fs-14">Select this option if you want to keep your insurance UNTIL your renewal date when this policy
                        will end</p>
                </>
            );
        } else if (key === CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_OPT_EXISTING_POLICY) {
            return (
                <>
                    Cancel before my renewal date
                    <p className="fs-14">Select this option if you want to cancel BEFORE your renewal date.<br/>
                        Note - if you cancel, there'll be a gap in your cover if you have alternative insurance starting on your renewal date
                    </p>
                </>
            );
        } else {
            return null;
        }
    }

    private handleCancellationChoice = (event: any) => {
        this.props.handleChoiceFunc(event.target.value);
        this.setState({cancellationChoice: event.target.value});
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/CancelPolicyOrAutomaticRenewalChoiceWidget.tsx